{
	"backToStartPage": "Terug naar startpagina",
	"transactionDetailsTitle": "Transactiedetails",
	"btnVerifyTransactions": "Transacties verifiëren",
	"kpi": {
		"date": "Datum",
		"quantity": "Hoeveelheid",
		"carbonReductions": "CO\u2082-reducties"
	},
	"verifyTransactionModal": {
		"title": "Transactie verifiëren",
		"description": "Voer de Record ID voor deze transactie in. U vindt deze informatie op de verklaring.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Annuleren",
		"verifyTitle": "Verifiëren",
		"errors": {
			"recordIdRequired": "Record ID is verplicht",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "De transactie kon niet worden geverifieerd. Controleer de Record ID"
		}
	},
	"errors": {
		"notFound": "Transactie niet gevonden"
	}
}
